import {i18n} from "translate/i18n";
import {swalQuestion} from "components/Swal";
import {newIndicator, setIndicators} from "services/Indicators.service";
import {toast} from "react-toastify";
import {value} from "lodash/seq";
import {useNavigate} from "react-router";

function changeTags(data) {
  return data.map(tag => ({
        id: tag.value,
        name: tag.label
    }))
}

function filterTags(data) {

    let tags = {}

    data.map(item => {
        let data = Object.values(item)
        let values = data[0].length === 0;

        if(!values) {
            tags = ({...tags,...item})
        }
    } )

    return tags
}

export const createIndicator = (values, tags, username) => {

    const tagsData = [
        {temas_materiais: changeTags(tags.temas_materiais)},
        {hashtag: changeTags(tags.hashtag)},
        {ods: changeTags(tags.ods)},
        {dimensao_gri: changeTags(tags.dimensao_gri)},
        {codigo_gri: changeTags(tags.codigo_gri)},
        {dimensao_sasb: changeTags(tags.dimensao_sasb)},
        {setor_sasb: changeTags(tags.setor_sasb)},
        {codigo_sasb: changeTags(tags.codigo_sasb)},
        {dim_m_c_stakeholder: changeTags(tags.dim_m_c_stakeholder)},
        {tcfd: changeTags(tags.tcfd)},
        {flag_compromissos: changeTags(tags.flag_compromissos)},
    ]

    const newTags = filterTags(tagsData)

    const newData = {
        codigo: values.codigo,
        titulo: values.titulo,
        contexto: values.contexto,
        links: values.links,
        racional: values.racional,
        notas_de_rodape: values.notas_de_rodape,
        informacoes_complementares: values.informacoes_complementares,
        orientacoes: values.orientacoes,
        tags: newTags,
        username: username,
        auditable: values.auditable,
        year_reference: values.year_reference
    }

    return newIndicator(newData)
        .then((response) => {
            return response.data
            toast.success('Indicador criado com sucesso')
        })
        .catch((error) => {
            console.log('error', error)
            toast.error(i18n.t('error.badRequest'))
        })
}

export const updateIndicator = (values, tags, username) => {

    console.log(values.auditable)

    const tagsData = [
        {temas_materiais: changeTags(tags.temas_materiais)},
        {hashtag: changeTags(tags.hashtag)},
        {ods: changeTags(tags.ods)},
        {dimensao_gri: changeTags(tags.dimensao_gri)},
        {codigo_gri: changeTags(tags.codigo_gri)},
        {dimensao_sasb: changeTags(tags.dimensao_sasb)},
        {setor_sasb: changeTags(tags.setor_sasb)},
        {codigo_sasb: changeTags(tags.codigo_sasb)},
        {dim_m_c_stakeholder: changeTags(tags.dim_m_c_stakeholder)},
        {tcfd: changeTags(tags.tcfd)},
        {flag_compromissos: changeTags(tags.flag_compromissos)},
    ]

    const newTags = filterTags(tagsData)

    let id = values.id

    const newData = {
        codigo: values.codigo,
        titulo: values.titulo,
        contexto: values.contexto,
        links: values.links,
        racional: values.racional,
        notas_de_rodape: values.notas_de_rodape,
        informacoes_complementares: values.informacoes_complementares,
        orientacoes: values.orientacoes,
        tags: newTags,
        username: username,
        auditable: values.auditable,
        year_reference: values.year_reference
    }

    swalQuestion(`${i18n.t('questions.editIndicator')} <b>${values.titulo}</b>?` ).then((result) => {
        if (result.isConfirmed) {
            setIndicators(id, newData)
                .then((response) => {
                    toast.success(i18n.t('success.editSuccessIndicator'))
                })
                .catch(() => toast.error(i18n.t('error.badRequest')))
        }
    })
}

export function changeStatus(status) {
    switch (status) {
        case 'draft':
            return {
                label: 'Repondente',
                bg: 'bg-warning'
            }
        case 'draft_en':
            return {
                label: 'Tradutor',
                bg: 'bg-warning'
            }
        case 'approved_en':
        case 'approved_pt':
            return {
                label: 'Aguardando aprovação',
                bg: 'bg-info'
            }
        case 'approval_esg':
            return {
                label: 'Líder ESG',
                bg: 'bg-info'
            }
        case 'evaluation_avesso':
            return {
                label: 'Avaliação - Avesso',
                bg: 'bg-primary'
            }
        case 'evaluation_suzano':
            return {
                label: 'Avaliação - Suzano',
                bg: 'bg-primary'
            }
        case 'evaluation_suzano_en':
            return {
                label: 'Avaliação - Suzano EN',
                bg: 'bg-primary'
            }
        case 'finished':
            case 'published':
            return {
                label: 'Publicado',
                bg: 'bg-success'
            }
        case 'finished_en':
            return {
                label: 'Publicado',
                bg: 'bg-success'
            }
        default:
             return {
                label: 'Rascunho',
                bg: 'bg-warning'
            }
    }
}
